import React from 'react';
import { Phone, CheckCircle, Truck, Clock, FileText, Calendar, Wrench } from 'lucide-react';
export function FleetServicePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6131">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6132">
        <div className="container mx-auto px-4" data-id="element-6133">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6134">
            FLEET MAINTENANCE PROGRAMS
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6135">
            Preventative Maintenance That Saves Time and Money
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6136">
        <div className="max-w-4xl mx-auto" data-id="element-6137">
          {/* The Problem */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6138">
            <p className="text-lg text-gray-700 mb-6" data-id="element-6139">
              <strong data-id="element-6140">
                Many truck and fleet owners ignore or postpone simple
                maintenance procedures because taking your trucks to service
                center eats up man-hours.
              </strong>{' '}
              Someone has to drop it off, someone has to pick that person up,
              and they both have to take more time to go back to retrieve the
              vehicle. You lose even more time and man-hours when you postpone
              or ignore scheduled maintenance schedules and end up with a
              breakdown on the side of the road for a problem that could have
              been prevented.
            </p>

            <div className="flex justify-center" data-id="element-6141">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/RED%20FLEET.jpg?opt=w3" alt="Fleet maintenance trucks" className="max-w-full h-auto rounded-lg shadow-md" data-id="element-6142" />
            </div>
          </div>

          {/* Our Solution */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6143">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6144">
              Our Preventative Maintenance Solution
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-6145">
              <strong data-id="element-6146">Garrett Auto & Truck Repair</strong> believes in
              preventative maintenance. We'll help you save time and money by
              providing the diagnostic, repair and replacement services
              recommended by your vehicle manufacturer.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-6147">
              Here's how Garrett Auto & Truck can take the hassle out of
              scheduled maintenance:
            </h3>

            <div className="space-y-4 mb-8" data-id="element-6148">
              <div className="flex items-start bg-blue-50 rounded-lg p-4" data-id="element-6149">
                <FileText className="text-blue-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-6150" />
                <p className="text-gray-700" data-id="element-6151">
                  We maintain your service records and D.O.T. recordkeeping
                  requirements in our state-of-the-art database.
                </p>
              </div>

              <div className="flex items-start bg-green-50 rounded-lg p-4" data-id="element-6152">
                <Calendar className="text-green-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-6153" />
                <p className="text-gray-700" data-id="element-6154">
                  When it's time for service, we'll notify you.
                </p>
              </div>

              <div className="flex items-start bg-purple-50 rounded-lg p-4" data-id="element-6155">
                <Truck className="text-purple-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-6156" />
                <p className="text-gray-700" data-id="element-6157">
                  Convenient scheduling options to minimize downtime for your
                  fleet.
                </p>
              </div>

              <div className="flex items-start bg-yellow-50 rounded-lg p-4" data-id="element-6158">
                <Clock className="text-yellow-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-6159" />
                <p className="text-gray-700" data-id="element-6160">
                  We'll inform you of any safety or reliability concerns, so
                  that you'll know exactly how long the vehicle will be out of
                  service.
                </p>
              </div>

              <div className="flex items-start bg-green-50 rounded-lg p-4" data-id="element-6161">
                <CheckCircle className="text-green-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-6162" />
                <p className="text-gray-700" data-id="element-6163">
                  Professional service to keep your fleet running reliably.
                </p>
              </div>
            </div>
          </div>

          {/* Services Offered */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6164">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-6165">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-6166" />
              Fleet Maintenance Services
            </h2>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-6167">
              <div className="flex items-start" data-id="element-6168">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6169" />
                <span className="text-gray-700" data-id="element-6170">Oil & filter changes</span>
              </div>

              <div className="flex items-start" data-id="element-6171">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6172" />
                <span className="text-gray-700" data-id="element-6173">Chassis lubrication</span>
              </div>

              <div className="flex items-start" data-id="element-6174">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6175" />
                <span className="text-gray-700" data-id="element-6176">Transmission service</span>
              </div>

              <div className="flex items-start" data-id="element-6177">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6178" />
                <span className="text-gray-700" data-id="element-6179">Brake adjustments</span>
              </div>

              <div className="flex items-start" data-id="element-6180">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6181" />
                <span className="text-gray-700" data-id="element-6182">Alignment</span>
              </div>

              <div className="flex items-start" data-id="element-6183">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6184" />
                <span className="text-gray-700" data-id="element-6185">
                  Cooling System Maintenance
                </span>
              </div>

              <div className="flex items-start" data-id="element-6186">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6187" />
                <span className="text-gray-700" data-id="element-6188">
                  Fuel Injection Service – gas & diesel
                </span>
              </div>

              <div className="flex items-start" data-id="element-6189">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6190" />
                <span className="text-gray-700" data-id="element-6191">Belt & hose replacement</span>
              </div>

              <div className="flex items-start" data-id="element-6192">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6193" />
                <span className="text-gray-700" data-id="element-6194">Clutch adjustments</span>
              </div>

              <div className="flex items-start" data-id="element-6195">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6196" />
                <span className="text-gray-700" data-id="element-6197">And much more</span>
              </div>
            </div>
          </div>

          {/* Benefits Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6198">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6199">
              Why Choose Our Fleet Maintenance Program?
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-6200">
              <div className="text-center" data-id="element-6201">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6202">
                  <Clock className="text-blue-600" size={32} data-id="element-6203" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6204">
                  Save Time
                </h3>
                <p className="text-gray-700" data-id="element-6205">
                  Convenient scheduling means minimal disruption to your
                  operations
                </p>
              </div>

              <div className="text-center" data-id="element-6206">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6207">
                  <CheckCircle className="text-green-600" size={32} data-id="element-6208" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6209">
                  Prevent Breakdowns
                </h3>
                <p className="text-gray-700" data-id="element-6210">
                  Regular maintenance prevents costly roadside emergencies
                </p>
              </div>

              <div className="text-center" data-id="element-6211">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6212">
                  <FileText className="text-purple-600" size={32} data-id="element-6213" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6214">
                  Stay Compliant
                </h3>
                <p className="text-gray-700" data-id="element-6215">
                  D.O.T. recordkeeping and service tracking included
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6216">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6217">
              Start Your Fleet Maintenance Program Today
            </h2>
            <p className="text-xl mb-6" data-id="element-6218">
              Keep your fleet running smoothly with our comprehensive
              maintenance program
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6219">
              <Phone className="mr-3" size={24} data-id="element-6220" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6221">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}